module.exports = __webpack_public_path__ + "static/img/listwa_1.7551ee9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia/listwa_1.svg
// module id = 03lB
// module chunks = 1